import { FETCH_SETTINGS_SUCCESS, LOG_OUT_SUCCESS } from 'actionTypes'

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT_SUCCESS:
      return initialState
    case FETCH_SETTINGS_SUCCESS:
      return action.settings
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js